export default __webpack_public_path__ + "static/media/b3.cfd42c29.svg";